import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import { FAQItem } from './parts';
import * as style from './style.css';
import { FAQ_ITEMS } from './utils/constants';

export const FAQ: React.FC = () => {
  return (
    <div data-testid="HomeownerFAQ" className={style['container']}>
      <div className={style['heading']}>
        <UIHeading1>Ответы на острые вопросы</UIHeading1>
      </div>

      <div className={style['wrapper']}>
        {FAQ_ITEMS.map((props, index) => (
          <FAQItem key={props.heading + index} {...props} />
        ))}
      </div>
    </div>
  );
};
